import React from "react";

const getClass = (prop) => "owl-options " + (prop.className || "");

const Options = ({ prop }) => {
    // const [, render] = React.useState(prop);
    console.debug("Options RD");
    const _class = getClass(prop);

    return (
        <select key={prop.key} defaultValue={prop.value} className={_class} onChange={onChange}>
            {prop.options.map((item) => (
                <option value={item.id} key={item.id}>
                    {item.title}
                </option>
            ))}
        </select>
    );

    function onChange(e) {
        let currentTarget = e.currentTarget;
        let value = e.target.value;
        prop.value = value;
        let founded = prop.options.find((o) => o.id == value);
        prop.className = founded?.className;
        currentTarget.className = getClass(prop);
        if (prop.storageKey) localStorage.setItem(prop.storageKey, value);

        if (prop.showInClearBar) {
            prop.titleValue = founded.title;
            prop.clear = () => {
                prop.value = prop.options[0].id;
                prop.className = prop.options[0]?.className;
                currentTarget.className = getClass(prop);
                currentTarget.value = prop.value;
                if (prop.storageKey) localStorage.setItem(prop.storageKey, prop.value);
            };
        }
        prop.queryChanged();
    }
};
export default Options;
